import React from 'react';
import { Description } from '../../Description';
import styles from './ImageCard.Metadata.scss';
export var ImageCardMetadata = function ImageCardMetadata(props) {
  return React.createElement("div", {
    "data-test": props.dataTest,
    className: styles.metadata
  }, props.label && React.createElement(Description, {
    variant: "condensed",
    className: styles.label,
    dataTest: "metadata-label"
  }, props.label), React.createElement(Description, {
    variant: "condensed",
    dataTest: "metadata-body"
  }, props.children));
};